export const PRODUCTS_URL = '/comsanty/api/products';
export const CATEGORIES_URL = '/comsanty/api/categories';
export const BRANDS_URL = '/comsanty/api/brands';
export const UPLOAD_URL = '/comsanty/api/upload';
export const USERS_URL = '/comsanty/api/users';
export const AUTH_URL = '/comsanty/api/auth';
export const PERSON_URL = '/contifico/api/v1/persona';
export const CART_URL = '/comsanty/api/cart';
export const ORDERS_URL = '/comsanty/api/orders';
export const PAYPHONE_URL = '/comsanty/api/payphone';
export const PAYPAL_URL = '/comsanty/api/config/paypal';
export const EVENTS_URL = '/comsanty/api/events';
export const STATS_URL = '/comsanty/api/stats';
export const SHIPPING_URL = '/comsanty/api/shipping';
export const COMPANIES_URL = '/comsanty/api/companies';
export const CONTIFICO_PRODUCT_URL = '/contifico/api/v1/producto';
export const CONTIFICO_BANCO_URL = '/contifico/api/v1/banco/cuenta';
export const CONTIFICO_PRODUCT_URL_V2 = '/contifico/api/v2/producto';
export const PARTNERS_URL = '/comsanty/api/partners'
export const PROMOTIONS_URL = '/comsanty/api/promotions';
export const ADMIN_NOTIFICATIONS_URL = '/comsanty/api/admin-notifications';
export const DISCOUNTS_URL = '/comsanty/api/discounts';
export const SEARCH_HISTORY_URL = '/comsanty/api/search-history';
export const SALES_REPORTS_URL = '/comsanty/api/reports/sales';

export const EC_TYPE_RUC = 'ruc';
export const EC_TYPE_CED = 'cedula';
export const EC_TYPE_EXT = 'pasaporte';
